// extracted by mini-css-extract-plugin
export default {"root":"primeFolder_root__qN5jd","active":"primeFolder_active__dfstP"};